import { render } from "./team-member-settings-header.vue?vue&type=template&id=515b95fc&scoped=true&ts=true"
import script from "./team-member-settings-header.vue?vue&type=script&lang=ts"
export * from "./team-member-settings-header.vue?vue&type=script&lang=ts"

import "./team-member-settings-header.vue?vue&type=style&index=0&id=515b95fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515b95fc"]])

export default __exports__